// Import necessary functions and modules
import { createApi } from "@reduxjs/toolkit/query/react";
import { apiSliceInterceptor } from "stores/redux/apiSliceInterceptor";


const Driver = createApi({
  reducerPath: "Driver",
  baseQuery: apiSliceInterceptor.baseQueryWithInterceptor,
  tagTypes: ["GETDRIVERLIST", "ADDDRIVER", "UPDATEDRIVER"],

  endpoints: (qb) => ({
    getDriversListApi: qb.query({
      query: (filters) => {
        const { role, isActive, page, limit, noGlobalLoading = true } = filters || {};

        // Construct params object dynamically, only including defined values
        const params = { page, limit, noGlobalLoading };
        if (role) params.role = role;
        if (typeof isActive === "boolean") {
          params.isActive = isActive;
        }


        // Log the API request to debug
        console.log("Fetching orders with params:", params);
        return {
          url: `api/user/users-by-role`,
          params,
        };
      },
      transformResponse: (response) => {
        console.log("API Response:", response); // ✅ Log the API response
        return response;
      },
      providesTags: ["GETDRIVERLIST"],
    }),


    addDriverApi: qb.mutation({
      query: (data) => ({
        url: `/api/user/register`,
        method: "POST",
        body: {
          role:data.role,
          name:data.name,
          email:data.email,
          mobile:data.mobile,
        },
      }),
      invalidatesTags: ["ADDDRIVER"],
    }),

    updateDriverApi: qb.mutation({
      query: ({ id, role, name,email,mobile,isActive }) => ({
          url: `/api/user/${id}`, // Append orderId to the URL
          method: "PUT",
          body: {
            role,
            name,
            email,
            mobile,
            status:isActive,
          },
        }),
      invalidatesTags: ["UPDATEDRIVER"],
    }),

  }),
});

export const DriversApiReducer = Driver.reducer;

export const driversApiAction = {
  middleware: Driver.middleware,
  reducerPath: Driver.reducerPath,
  getDriversListApi: Driver.useGetDriversListApiQuery,
  addDriverApi: Driver.useAddDriverApiMutation,
  updateDriverApi: Driver.useUpdateDriverApiMutation,
};

